var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mytable',{ref:"mytable",attrs:{"tree":{children: 'children', lazy: _vm.lazyLoad},"tableColums":_vm.tableColums_getUserTargetList,"api":"getProjectAnalysis::dtId","xupdateapi":"updateUserTarget","height":_vm.H-165},on:{"expand":_vm.expand}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f13e530","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/discoveries/ProjectAnalysis.vue
// module id = null
// module chunks = 